import { Box, Grid, Stack, Typography } from '@mui/material'
import CustomToolTip from '../common/toolTip'
import custom from '../../styles/mui/szVariables.json'


export default function ChartTotals({ id, content, tou }: any) { 
  const message = (
    <Box sx={{
            color: 'text.primary',
            backgroundColor: '#FFF',
            p: custom.spacing.sm
        }}>
        <Grid container direction="row" rowSpacing={custom.spacing.sm}>
            <Grid item xs={6}>
                <Typography color="text.primary" 
                  variant="szBody.Regular.Medium">
                      {content.totalTitle}
                </Typography>
            </Grid>
            <Grid item xs={6} justifyContent={"flex-end"} display="flex">
                <Typography textAlign={"right"} 
                  variant="szBody.Regular.Medium">
                      {content.total} kWh
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography color="text.primary" 
                  variant="szBody.Regular.Medium">
                      {content.totalTitle2}
                </Typography>
            </Grid>
            <Grid item xs={6} justifyContent={"flex-end"} display="flex">
                <Typography textAlign={"right"} 
                  variant="szBody.Regular.Medium">
                      -{content.total2} kWh
                </Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography color="text.primary" 
                  variant="szBody.Bold.Medium">
                      {content.netTitle}
                </Typography>
            </Grid>
            <Grid item xs={6} justifyContent={"flex-end"} display="flex">
                <Typography textAlign={"right"} 
                  variant="szBody.Bold.Medium">
                      {content.net} kWh
                </Typography>
            </Grid>
        </Grid>
    </Box>
  )
  return (
    <Stack alignItems="start" direction="row" 
          justifyContent="space-between"
          >
      <Box>
          <Typography color="text.primary" 
              variant="szBody.Regular.Medium"
              id={id+'ChartTitle'}>
              {tou && id==='grid'?content.netTitle:content?.totalTitle}
              {tou && id==='grid' &&
                <CustomToolTip 
                    content={message} 
                    backColor="#FFF"
                    color="text.primary"
                    placement="right" >                           
                    <Box component="img"
                        height={custom.sizes.sm} 
                        width={custom.sizes.sm}
                        src = {`/images/Question.svg`}
                        sx={{ 
                            ml: custom.spacing.xxxs
                        }} />
                </CustomToolTip>
            }
          </Typography>
          <Typography component={"p"} 
              id={id+'ChartTotalValue'}
              variant="szHeading.Bold.xLarge">
              {tou && id==='grid'?content.net:content?.total}
              <Typography sx={{ ml: custom.spacing.xxxxs }} 
                  variant="szHeading.Regular.xxSmall">
                      kWh
              </Typography>
          </Typography>
      </Box>
      {(tou && id==='grid')?'':
        <Box sx={{ marginLeft:'auto'}} >
            <Typography color="text.primary" 
                variant="szBody.Regular.Medium" 
                id={id+'ChartTitle2'}>
                {content?.totalTitle2 || ''}
            </Typography>
            <Typography component={"p"} 
                variant="szHeading.Bold.xLarge" 
                align="right" id={id+'ChartTotalValue2'}>
                { content?.totalTitle2 ?
                    content?.total2 : ''}
                <Typography sx={{ ml: custom.spacing.xxxxs }} 
                    variant="szHeading.Regular.xxSmall">
                    { content?.totalTitle2 ?'kWh':''}
                </Typography>
            </Typography>
        </Box>
        }
      </Stack>
  )
}
